import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { IocProvider, container } from '@mchs/web-core';
import { MessengerServiceRegistration } from './services/messenger';
import { AppContextProvider } from './components/context/AppContext';

interface SchedulingWidgetInitialization {
  practitionerId: string;
  cattailsProviderId: string;
  providerName: string;
}

/* Register the messenger service with the container */
const messengerRegistration = new MessengerServiceRegistration(container);
messengerRegistration.register();

class SchedulingWidgetObject {
  public init(widgetInitialization: SchedulingWidgetInitialization) {
    const widgetElement = document.getElementById('scheduling-widget');
    if (widgetElement !== null) {
      ReactDOM.createRoot(widgetElement).render(
        <IocProvider container={container}>
          <BrowserRouter>
            <AppContextProvider>
              <App
                practitionerId={widgetInitialization.practitionerId}
                cattailsProviderId={widgetInitialization.cattailsProviderId}
                providerName={widgetInitialization.providerName}
              />
            </AppContextProvider>
          </BrowserRouter>
        </IocProvider>
      );
    }
  }
}

export const SchedulingWidget = new SchedulingWidgetObject();
